<div class="team-member-card" [class.team-member-card--add]="showCommitButton" [formGroup]="memberForm">

  @if (cardTitle) {
    <h4 class="team-member-card__title">{{ cardTitle }}</h4>
  }

  <div class="team-member-card__inner">

    <!-- Photo Upload Circle -->
    <div class="team-member-card__photo-container">
      @if (photoUrl) {
        <div class="team-member-card__photo-circle team-member-card__photo-circle--filled"
             (click)="onPhotoClick()">
          <img class="team-member-card__photo-img" [src]="photoUrl" alt="">
        </div>
      } @else {
        <div class="team-member-card__photo-circle" (click)="onPhotoClick()">
          <svg width="28" height="28" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M23 19C23 19.5304 22.7893 20.0391 22.4142 20.4142C22.0391 20.7893 21.5304 21 21 21H3C2.46957 21 1.96086 20.7893 1.58579 20.4142C1.21071 20.0391 1 19.5304 1 19V8C1 7.46957 1.21071 6.96086 1.58579 6.58579C1.96086 6.21071 2.46957 6 3 6H7L9 3H15L17 6H21C21.5304 6 22.0391 6.21071 22.4142 6.58579C22.7893 6.96086 23 7.46957 23 8V19Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            <circle cx="12" cy="13" r="4" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
          <span class="team-member-card__photo-label">
            {{ 'settings.project_details_form.upload_photo_label' | translate }}
          </span>
        </div>
      }
      <input
        type="file"
        #photoInput
        accept="image/jpeg,image/jpg,image/bmp,image/png,image/jfif,image/webp"
        style="display: none;"
        (change)="onFileSelected($event)">
    </div>

    <!-- Form Fields -->
    <div class="team-member-card__fields">

      <!-- Full Name & Title (full width) -->
      @if (nameTitleVisible !== false) {
        <div class="team-member-card__field-row">
          <div class="team-member-card__field team-member-card__field--full">
            <label class="team-member-card__label">
              {{ 'settings.project_details_form.team_member_name_title_label' | translate }}@if (nameTitleRequired ?? isRequired(nameTitleControlName)) { <span class="team-member-card__required">*</span> }
            </label>
            <input
              type="text"
              class="team-member-card__input"
              [formControlName]="nameTitleControlName"
              [class.team-member-card__input--error]="memberForm.get(nameTitleControlName)?.invalid && memberForm.get(nameTitleControlName)?.touched"
              [placeholder]="'settings.project_details_form.team_member_name_title_placeholder' | translate">
            @if (memberForm.get(nameTitleControlName)?.hasError('required') && memberForm.get(nameTitleControlName)?.touched) {
              <div class="team-member-card__error">{{ 'settings.project_details_form.required_field' | translate }}</div>
            }
          </div>
        </div>
      }

      <!-- Email + Bio row -->
      @if (emailVisible !== false || bioVisible !== false) {
        <div class="team-member-card__field-row">
          @if (emailVisible !== false) {
            <div class="team-member-card__field">
              <label class="team-member-card__label">
                {{ 'settings.project_details_form.team_member_email_label' | translate }}@if (emailRequired ?? isRequired(emailControlName)) { <span class="team-member-card__required">*</span> }
              </label>
              <input
                type="email"
                class="team-member-card__input"
                [formControlName]="emailControlName"
                [class.team-member-card__input--error]="memberForm.get(emailControlName)?.invalid && memberForm.get(emailControlName)?.touched"
                [placeholder]="'settings.project_details_form.team_member_email_placeholder' | translate">
              @if (memberForm.get(emailControlName)?.hasError('required') && memberForm.get(emailControlName)?.touched) {
                <div class="team-member-card__error">{{ 'settings.project_details_form.required_field' | translate }}</div>
              }
            </div>
          }
          @if (bioVisible !== false) {
            <div class="team-member-card__field">
              <label class="team-member-card__label">
                {{ 'settings.project_details_form.team_member_bio_label' | translate }}@if (bioRequired ?? isRequired(bioControlName)) { <span class="team-member-card__required">*</span> }
              </label>
              <input
                type="text"
                class="team-member-card__input"
                [formControlName]="bioControlName"
                [class.team-member-card__input--error]="memberForm.get(bioControlName)?.invalid && memberForm.get(bioControlName)?.touched"
                [placeholder]="'settings.project_details_form.team_member_bio_placeholder' | translate"
                maxlength="500">
              @if (memberForm.get(bioControlName)?.hasError('required') && memberForm.get(bioControlName)?.touched) {
                <div class="team-member-card__error">{{ 'settings.project_details_form.required_field' | translate }}</div>
              }
            </div>
          }
        </div>
      }

      <!-- Optional LinkedIn row -->
      @if (linkedinControlName && linkedinVisible !== false) {
        <div class="team-member-card__field-row">
          <div class="team-member-card__field team-member-card__field--full">
            <label class="team-member-card__label">
              {{ 'settings.charity_details_form.linkedin_profile_label' | translate }}@if (linkedinRequired ?? isRequired(linkedinControlName)) { <span class="team-member-card__required">*</span> }
            </label>
            <input
              type="url"
              class="team-member-card__input"
              [formControlName]="linkedinControlName"
              [class.team-member-card__input--error]="memberForm.get(linkedinControlName)?.invalid && memberForm.get(linkedinControlName)?.touched"
              [placeholder]="'settings.charity_details_form.linkedin_url_placeholder' | translate">
          </div>
        </div>
      }

    </div>
  </div>

  <!-- Commit (Add) button -->
  @if (showCommitButton) {
    <div class="team-member-card__commit-row">
      <button type="button" class="team-member-card__commit-btn" (click)="onCommit()">
        {{ commitLabel || ('settings.project_details_form.add_team_member_confirm' | translate) }}
      </button>
    </div>
  }

  <!-- Remove button -->
  @if (showRemoveButton) {
    <button type="button" class="team-member-card__remove-btn" (click)="onRemove()">
      {{ removeLabel || ('settings.project_details_form.remove_team_member' | translate) }}
    </button>
  }

</div>
